export const json = {
  locale: 'ar_sa',
  recipe: "وصفة",
  machine: "آلة",
  task: {
    state: {
      unset: "غير محدد",
      todo: "للقيام به",
      in_progress: "قيد التنفيذ",
      to_test: "للاختبار",
      wont_fix: "لن يتم إصلاحه",
      done: "تم",
      paused: "متوقف مؤقتًا",
    },
    priority: {
      unset: "بدون أولوية",
      low: "منخفضة",
      normal: "عادية",
      high: "عالية",
      max: "عاجلة",
    },
    table: {
      header: {
        title: "المهمة",
        state: "الحالة",
        priority: "الأولوية",
        labels: "التصنيفات",
      },
      placeholder: {
        filter: {
          priority: "تصفية الرسائل الإلكترونية...",
        },
      },
      "no-results": "لا توجد نتائج",
    },
    add: {
      title: "إضافة مهمة جديدة",
      name: "اسم المهمة",
      name_placeholder: "أدخل اسم المهمة",
      priority: "الأولوية",
      title_translations: "ترجمات العنوان",
      description_translations: "ترجمات الوصف",
      icon_url: "رابط الأيقونة (اختياري)",
      icon_url_placeholder: "أدخل رابط الأيقونة",
      labels: "التصنيفات",
      assigned_to: "مُسند إلى",
      assigned_to_placeholder: "اختر مشرفًا",
      submit: "إنشاء المهمة",
      cancel: "إلغاء",
      edit_translations: "تعديل الترجمات",
      save_translations: "حفظ الترجمات",
      required_field: "هذا الحقل مطلوب",
      en_us_required: "الترجمة الإنجليزية (الولايات المتحدة) مطلوبة",
      success: "تم إنشاء المهمة بنجاح!",
      error: "خطأ في إنشاء المهمة. يرجى المحاولة مرة أخرى.",
    },
  },
  table: {
    select: {
      of: "من",
      rows: "صف (صفوف) محددة.",
    },
  },
  cookies: {
    link: 'سياسة ملفات تعريف الارتباط',
    title: "موافقة ملفات تعريف الارتباط",
    description:
      "يستخدم هذا الموقع ملفات تعريف الارتباط لضمان عمله بشكل صحيح وتحسين تجربتك. يرجى تحديد ملفات تعريف الارتباط التي تسمح لنا باستخدامها.",
    policy_link: "تعرف على المزيد في سياسة ملفات تعريف الارتباط",
    accept_all: "قبول الكل",
    accept_selected: "قبول المحدد",
    accept_essential: "الضرورية فقط",
    manage: "إدارة التفضيلات",
    save: "حفظ التفضيلات",
    back: "رجوع",
    categories: {
      essential: {
        title: "ملفات تعريف الارتباط الضرورية",
        description: "هذه الملفات ضرورية لعمل الموقع ولا يمكن تعطيلها.",
      },
      functional: {
        title: "ملفات تعريف الارتباط الوظيفية",
        description: "تمكن هذه الملفات الميزات والوظائف المخصصة.",
      },
      analytics: {
        title: "ملفات تعريف الارتباط التحليلية",
        description: "تساعدنا هذه الملفات على فهم كيفية تفاعل الزوار مع الموقع.",
      },
      marketing: {
        title: "ملفات تعريف الارتباط التسويقية",
        description: "تُستخدم هذه الملفات لتتبع الزوار عبر المواقع لأغراض الإعلان.",
      },
    },
    expiration: {
      title: "انتهاء صلاحية ملفات تعريف الارتباط",
      description: "اختر المدة التي سيتم فيها تذكر تفضيلات ملفات تعريف الارتباط الخاصة بك:",
      thirty_days: "30 يومًا",
      ninety_days: "90 يومًا",
      six_months: "6 أشهر",
      one_year: "سنة واحدة",
    },
    policy: {
      title: "سياسة ملفات تعريف الارتباط",
      introduction:
        "توضح سياسة ملفات تعريف الارتباط هذه كيفية استخدامنا لملفات تعريف الارتباط والتقنيات المماثلة للتعرف عليك عند زيارة موقعنا. وتشرح ماهية هذه التقنيات ولماذا نستخدمها، بالإضافة إلى حقوقك في التحكم في استخدامنا لها.",
      what_are_cookies: "ما هي ملفات تعريف الارتباط؟",
      what_are_cookies_text:
        "ملفات تعريف الارتباط هي ملفات بيانات صغيرة يتم وضعها على جهاز الكمبيوتر أو الجهاز المحمول عند زيارة موقع ويب. تُستخدم ملفات تعريف الارتباط على نطاق واسع من قبل أصحاب المواقع لجعل مواقعهم تعمل، أو تعمل بكفاءة أكبر، بالإضافة إلى توفير معلومات التقارير.",
      how_we_use: "كيف نستخدم ملفات تعريف الارتباط",
      how_we_use_text:
        "نستخدم ملفات تعريف الارتباط لعدة أسباب. بعض ملفات تعريف الارتباط مطلوبة لأسباب تقنية حتى يعمل موقعنا، ونشير إليها باسم ملفات تعريف الارتباط 'الأساسية' أو 'الضرورية'. تمكننا ملفات تعريف الارتباط الأخرى من تتبع واستهداف اهتمامات مستخدمينا لتحسين التجربة على موقعنا. تقدم جهات خارجية ملفات تعريف الارتباط من خلال موقعنا للإعلان والتحليلات وأغراض أخرى.",
      types: "أنواع ملفات تعريف الارتباط التي نستخدمها",
      managing: "إدارة ملفات تعريف الارتباط الخاصة بك",
      managing_text:
        "يمكنك ضبط أو تعديل عناصر التحكم في متصفح الويب الخاص بك لقبول أو رفض ملفات تعريف الارتباط. إذا اخترت رفض ملفات تعريف الارتباط، فلا يزال بإمكانك استخدام موقعنا على الرغم من أن وصولك إلى بعض الوظائف والمناطق في موقعنا قد يكون مقيدًا. نظرًا لأن وسائل رفض ملفات تعريف الارتباط من خلال عناصر التحكم في متصفح الويب تختلف من متصفح إلى آخر، يجب عليك زيارة قائمة المساعدة في متصفحك للحصول على مزيد من المعلومات.",
      third_party: "ملفات تعريف الارتباط من جهات خارجية",
      third_party_text:
        "بالإضافة إلى ملفات تعريف الارتباط الخاصة بنا، قد نستخدم أيضًا ملفات تعريف ارتباط مختلفة من جهات خارجية للإبلاغ عن إحصائيات استخدام الموقع، وتقديم الإعلانات على الموقع ومن خلاله، وما إلى ذلك.",
      updates: "تحديثات سياسة ملفات تعريف الارتباط هذه",
      updates_text:
        "قد نقوم بتحديث سياسة ملفات تعريف الارتباط هذه من وقت لآخر من أجل عكس، على سبيل المثال، التغييرات في ملفات تعريف الارتباط التي نستخدمها أو لأسباب تشغيلية أو قانونية أو تنظيمية أخرى. لذلك، يرجى إعادة زيارة سياسة ملفات تعريف الارتباط هذه بانتظام للبقاء على اطلاع حول استخدامنا لملفات تعريف الارتباط والتقنيات ذات الصلة.",
      purpose: "الغرض",
      essential_purpose:
        "ضرورية لعمل الموقع بشكل صحيح. تمكن ملفات تعريف الارتباط هذه الوظائف الأساسية مثل التنقل في الصفحة والوصول إلى المناطق الآمنة من الموقع.",
      functional_purpose:
        "تسمح للموقع بتذكر الاختيارات التي تقوم بها (مثل اسم المستخدم أو اللغة أو المنطقة التي أنت فيها) وتوفير ميزات محسنة وأكثر شخصية.",
      analytics_purpose:
        "تساعدنا على فهم كيفية تفاعل الزوار مع موقعنا من خلال جمع المعلومات والإبلاغ عنها بشكل مجهول.",
      marketing_purpose:
        "تُستخدم لتتبع الزوار عبر المواقع. الهدف هو عرض إعلانات ذات صلة وجذابة للمستخدم الفردي.",
      always_active: "نشط دائمًا",
      active: "نشط",
      inactive: "غير نشط",
      back_to_site: "العودة إلى الموقع",
    },
  },
  sidebar: {
    platform: "المنصة",
    dashboard: "لوحة التحكم",
    tasks: {
      title: "المهام",
      add: "إضافة مهمة"
    },
    analytics: "التحليلات",
    users: "المستخدمون",
    settings: "الإعدادات",
    admin_panel: {
      title: "لوحة الإدارة",
      mods: {
        title: "المشرفون",
        add: "إضافة مشرف"
      },
      labels: {
        title: "التصنيفات",
        add: "إضافة تصنيف"
      },
      pending: "الموافقات المعلقة"
    },
    documentation: {
      title: "الوثائق",
      create: "إنشاء وثيقة"
    },
    search: "البحث في الوثائق..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "نظرة عامة",
          userInfo: "معلومات المستخدم",
          userId: "معرف المستخدم",
          role: "الدور",
          memberSince: "عضو منذ"
        },
        tasks: {
          title: "المهام",
          assigned: "المهام المُسندة",
          noTasks: "لم يتم تعيين مهام بعد."
        },
        activity: {
          title: "النشاط",
          recent: "النشاط الأخير",
          noActivity: "لا يوجد نشاط حديث."
        },
        settings: {
          title: "الإعدادات",
          user: "إعدادات المستخدم",
          admin: "إعدادات الإدارة لهذا المستخدم."
        }
      }
    },
    mods: {
      error: {
        unknownError: "خطأ غير معروف"
      },
      access: {
        title: "تم رفض الوصول",
        description: "ليس لديك إذن للوصول إلى هذه الصفحة."
      },
      add: {
        link: "إضافة مود جديد",
        title: "إضافة مود جديد",
        addDesc: "إنشاء إدخال مود جديد",
        name: {
          title: "الاسم",
          placeholder: "أدخل اسم المود"
        },
        description: {
          title: "الوصف",
          placholder: "أدخل الوصف في "
        },
        optional: "اختياري",
        versions: {
          title: "الإصدارات",
          add: "إضافة إصدار"
        },
        icon: "رابط الأيقونة",
        launchers: "المشغلات",
        form: {
          errors: {
            alert: {
              title: "خطأ",
              description: "يرجى إصلاح الأخطاء أعلاه قبل الإرسال."
            },
            name: "الاسم مطلوب",
            description: "الوصف باللغة الإنجليزية (الولايات المتحدة) مطلوب",
            curseforge: "رابط CurseForge مطلوب",
            invalidURL: "تنسيق URL غير صالح",
            versions: "مطلوب إصدار واحد على الأقل",
            launchers: "مطلوب مشغل واحد على الأقل"
          }
        },
        cancel: "إلغاء",
        create: {
          loading: "جاري الإنشاء...",
          default: "إنشاء مود"
        },
        langDataError: "خطأ في تحميل بيانات اللغة:",
      },
      noMods: "لم يتم العثور على مودات",
      getStarted: "ابدأ بإنشاء مود جديد.",
      fetch: {
        error: 'خطأ في جلب الوثائق:'
      },
      "delete": {
        link: "حذف",
        confirm: "هل أنت متأكد أنك تريد حذف هذا المود؟"
      },
      toast: {
        delete: {
          success: {
            title: "تم حذف المود",
            description: "تم حذف المود بنجاح."
          },
          error: {
            console: "خطأ في حذف المود:",
            fallback: "فشل في حذف المود",
            title: "خطأ",
            description: "حدث خطأ أثناء حذف المود."
          }
        },
        edit: {
          success: {
            title: "نجاح",
            description: "تم تحديث المود بنجاح"
          }
        },
        add: {
          fallback: "فشل في إنشاء المود",
          success: {
            title: "نجاح",
            description: "تم إنشاء المود بنجاح"
          },
          console: "خطأ في إنشاء المود:",
          error: {
            title: "خطأ",
            description: "فشل في إنشاء المود"
          }
        }
      },
      noDesc: "لا يوجد وصف متاح",
      docs: {
        link: "الوثائق"
      },
      edit: {
        link: "تعديل",
        title: "تعديل المود",
        langDataError: "خطأ في تحميل بيانات اللغة:",
        notFound: "لم يتم العثور على المود",
        failFetch: "فشل في جلب المود",
        unknownError: "حدث خطأ غير معروف",
        form: {
          errors: {
            name: "الاسم مطلوب",
            description: "الوصف باللغة الإنجليزية (الولايات المتحدة) مطلوب",
            curseforge: "رابط CurseForge مطلوب",
            versions: "يجب ملء جميع حقول الإصدار",
            launchers: "يجب تحديد مشغل واحد على الأقل"
          }
        },
        modInfo: "معلومات المود",
        editModInfo: "تعديل معلومات المود.",
        name: "الاسم",
        description: {
          title: "الوصف",
          required: "الوصف باللغة الإنجليزية (الولايات المتحدة) مطلوب."
        },
        optional: "اختياري",
        versions: {
          title: "الإصدارات",
          add: "إضافة إصدار",
          remove: "إزالة"
        },
        icon: "رابط الأيقونة",
        launchers: "المشغلات",
        cancel: "إلغاء",
        update: "تحديث المود"
      }
    },
    docs: {
      access: {
        title: "تم رفض الوصول",
        description: "ليس لديك إذن للوصول إلى هذه الصفحة."
      },
      title: "الوثائق",
      description: "تصفح وقراءة وثائق مودات ماينكرافت",
      create: {
        link: "إنشاء وثائق",
        tab: "إنشاء جديد",
        content: {
          title: "لا توجد مودات متاحة",
          description: "جميع المودات لديها وثائق بالفعل أو ليس لديك إذن لإنشاء وثائق لأي مود."
        },
        title: "إنشاء وثائق"
      },
      published: "منشور",
      pending: "قيد الانتظار",
      noDocs: {
        title: "لا توجد وثائق متاحة",
        description: "لا توجد صفحات وثائق منشورة بعد."
      },
      noPending: {
        title: "لا توجد وثائق معلقة",
        superAdmin: "لا توجد صفحات وثائق تنتظر الموافقة",
        rest: "ليس لديك أي صفحات وثائق معلقة."
      },
      user: {
        noDocs: {
          title: "لا توجد وثائق متاحة",
          description: "لا توجد صفحات وثائق منشورة بعد."
        }
      },
      card: {
        pending: "في انتظار الموافقة",
        view: "عرض",
        edit: "تعديل"
      },
      add: {
        title: "إنشاء وثائق جديدة",
        description: "إنشاء وثائق شاملة لمود ماينكرافت",
        noMods: {
          title: "لا توجد مودات متاحة",
          description: "لا توجد مودات متاحة لإنشاء الوثائق. إما أن جميع المودات لديها وثائق بالفعل أو ليس لديك إذن لإنشاء وثائق لأي مود."
        },
        card: {
          title: "المعلومات الأساسية",
          description: "قدم معلومات أساسية حول الوثائق.",
          descriptionLink: "عرض دليل الوثائق الخاص بنا",
          content: {
            modSelect: "اختر مود",
            modSelectDesc: "اختر المود الذي تريد إنشاء وثائق له",
            noDesc: "لا يوجد وصف متاح",
            form: {
              title: {
                title: "العنوان",
                placeholder: "أدخل عنوان الوثائق",
                description: "عنوان الوثائق الخاصة بك (الإنجليزية الأمريكية مطلوبة)"
              },
              description: {
                title: "الوصف",
                placeholder: "أدخل وصف الوثائق",
                description: "وصف موجز للوثائق الخاصة بك (الإنجليزية الأمريكية مطلوبة)"
              },
              coverImage: {
                title: "رابط صورة الغلاف (اختياري)",
                description: "قدم رابطًا لصورة غلاف الوثائق الخاصة بك"
              },
              tabs: {
                preview: {
                  title: "معاينة",
                  content: {
                    title: "معاينة",
                    description: "معاينة كيف ستبدو وثائقك",
                    form: {
                      title: "عنوان الوثائق",
                      description: "سيظهر وصف الوثائق هنا."
                    },
                    section: "قسم",
                    article: "مقالة",
                    modSelect: {
                      title: "اختر مود",
                      description: "اختر مود لمعاينة الوثائق الخاصة بك"
                    }
                  }
                },
                information: {
                  title: "معلومات",
                  content: {
                    title: "معلومات",
                    description: "معلومات مهمة حول إنشاء الوثائق",
                    approval: {
                      title: "الموافقة مطلوبة",
                      description: "الوثائق التي ينشئها المحررون والمسؤولون تتطلب موافقة من مسؤول أعلى قبل أن تصبح عامة. افتح تذكرة لطلب ذلك."
                    },
                    after: {
                      title: "بعد الإنشاء:",
                      list: {
                        one: "ستتم إعادة توجيهك إلى محرر الوثائق",
                        two: "سيتم إنشاء قسم ومقالة افتراضية تلقائيًا",
                        three: "يمكنك إضافة المزيد من الأقسام والمقالات حسب الحاجة",
                        four: "يمكنك تحميل الصور وإضافة مكونات مخصصة",
                        five: "يمكنك معاينة الوثائق قبل تقديمها للموافقة. (يجب حفظها قبل المعاينة)"
                      }
                    },
                    create: {
                      loading: "جاري الإنشاء...",
                      default: "إنشاء وثائق"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "فشل في جلب المودات",
          documentation: "فشل في جلب الوثائق"
        },
        success: {
          title: "تم إنشاء الوثائق",
          description: "تم إنشاء الوثائق الخاصة بك بنجاح."
        },
        error: {
          fetching: {
            mods: {
              console: "خطأ في جلب المودات:",
              toast: {
                title: "خطأ",
                description: "فشل في تحميل المودات. يرجى المحاولة مرة أخرى."
              }
            }
          },
          creating: {
            failed: "فشل في إنشاء الوثائق",
            error: {
              console: "خطأ في إنشاء الوثائق:",
              toast: {
                title: "خطأ",
                description: "فشل في إنشاء الوثائق. يرجى المحاولة مرة أخرى."
              }
            }
          }
        }
      }
    }
  }
}